import {
  CreateLocationRequest,
  Location,
  ApiClientError,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useCreateLocation() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    Location,
    ApiClientError,
    { params: CreateLocationRequest }
  >(({ params }) => raydiant.createLocation(params), {
    onSuccess: () => {
      queryClient.invalidateQueries(keys.locations());
      queryClient.invalidateQueries(keys.pendingLocations());
    },
  });

  return mutation;
}
